<template>
  <div class="row justify-content-center mt-4 mb-4">
    <div class="col-md-10">
      <form
        class="form-horizontal "
        role="form"
      >
        <h5 class="d-flex justify-content-center">
          Add New Class to {{ formatDateDisplayLocal(date) }}
        </h5>
        <hr />

        <div class="form-group form-inline">
          <label
            for="classname"
            class="control-label mr-3"
          >Class</label>
          <select
            class="form-control ml-2"
            name=" classname"
            v-model="newclass.name"
          >
            <option
              v-for="(item, index) in pgclass"
              :key="index"
              :value="index"
            >{{ item }}</option>
          </select>
        </div>
        <div class="form-group form-inline">
          <label
            for="start_at"
            class="control-label mr-3"
          >Start At</label>
          <vue-timepicker
            :hour-range="[[6, 21]]"
            :minute-interval="5"
            v-model="newclass.start_at"
            @input="startAtInput"
            auto-scroll
            lazy
          ></vue-timepicker>

          <label
            for="start_at"
            class="control-label mr-3 ml-4"
          >End At</label>
          <vue-timepicker
            :hour-range="[[6, 22]]"
            :minute-interval="5"
            v-model="newclass.end_at"
            @input="endAtInput"
            auto-scroll
            lazy
          ></vue-timepicker>
        </div>
        <div class="form-group form-inline">
          <label
            for="room"
            class="control-label mr-3"
          >Room</label>
          <select
            class="form-control ml-2"
            name="room"
            v-model="newclass.room"
          >
            <option
              v-for="(item, index) in pgroom"
              :key="index"
              :value="index"
            >{{ item }}</option>
          </select>
        </div>
        <div class="form-group form-inline">
          <label
            for="maxamount"
            class="control-label mr-3"
          >Max</label>
          <input
            type="text"
            id="maxamount"
            placeholder="Maximum Attendance"
            class="form-control"
            v-model="newclass.maxamount"
          />
        </div>
        <div class="form-group form-inline">
          <label
            for="coach"
            class="control-label mr-3"
          >Coach</label>
          <select
            class="form-control ml-2"
            name="coach"
            v-model="newclass.coach"
          >
            <option
              v-for="(item, index) in pgcoach"
              :key="index"
              :value="index"
            >{{ item }}</option>
          </select>
        </div>
        <div class="form-group mb-3">
          <div class="mb-2">Add this class to</div>
          <div class="form-check mb-2">
            <input
              class="form-check-input"
              type="radio"
              name="period_end"
              id="period_end_today"
              value="1"
              @click="newclass.period_end = null"
              v-model="newclass.istoday"
            />
            <label
              class="form-check-label ml-3"
              for="period_end_today"
            >Only {{ formatDateDisplayLocal(date) }}</label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="period_end"
              id="period_end_until"
              value="0"
              v-model="newclass.istoday"
            />
            <label
              class="form-check-label mr-3  ml-3"
              for="period_end_until"
            >Until</label>
            <date-picker
              v-if="newclass.istoday != 1"
              v-model="newclass.period_end"
              valueType="format"
            ></date-picker>
          </div>
        </div>
        <hr />
        <div
          v-if="hasError"
          class="alert alert-danger"
          role="alert"
        >
          Some fields are missing. Please fill all.
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="AddNewClass"
          >
            Add Class
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { getDateFormat, formatDateDisplay } from "./../js/utils/date.js";
import { PGCLASS, PGROOM, PGCOACH } from "./../js/utils/global.js";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  props: ["date", "dow"],
  components: { VueTimepicker, DatePicker },
  data() {
    return {
      newclass: {
        name: null, //"TABATA",
        start_at: null, //"07:30",
        end_at: null, //"08:20",
        room: null, //"1",
        maxamount: 15,
        coach: null, //"1",
        istoday: null,
        period_end: null, // "2020-07-01"
        targetday: this.date,
        dow: this.dow
      },
      loading: false,
      hasError: false
    };
  },
  computed: {
    pgclass() {
      return PGCLASS;
    },
    pgroom() {
      return PGROOM;
    },
    pgcoach() {
      return PGCOACH;
    }
  },
  mounted() {
    //console.log(this.date);
    //console.log(PGCLASS);
  },
  methods: {
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    },
    startAtInput(eventData) {},
    endAtInput(eventData) {},
    async AddNewClass() {
      this.hasError = false;
      if (
        this.newclass.name == null ||
        this.newclass.start_at == null ||
        this.newclass.end_at == null ||
        this.newclass.room == null ||
        this.newclass.maxamount == null ||
        this.newclass.coach == null ||
        this.newclass.istoday == null ||
        this.newclass.targetday == null ||
        this.newclass.dow == null
      ) {
        this.hasError = true;
        return false;
      }

      //console.log(this.newclass);
      //return;

      this.loading = true;
      await axios
        .post("/api/classes/addnewclass", {
          newclass: this.newclass
        })
        .then(response => {
          this.$emit("close");
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.form-check-input {
  width: 20px;
  height: 20px;
}
</style>
